import React, {useEffect,useState} from 'react';
import {getFilterQcStatus} from "../../../microComponents/tablePages/getFilterQcStatus";
import FilterSelectOption from "../../../microComponents/tablePages/filter/FilterSelectOption";

const FilterQcStatus = () => {
    const [qcStatusList, setQcStatusList] = useState([]);
    const [qcStatusLoading, setQcStatusLoading] = useState(false);
    useEffect(() => {
        getFilterQcStatus(setQcStatusList, setQcStatusLoading)

    }, []);
    return (
        <FilterSelectOption data={{
            placeholder: 'QC', filterName: 'qcStatus',

            options: qcStatusList, loading: qcStatusLoading,

        }}/>
    );
};

export default FilterQcStatus;